import Layout from '@/views/Layout/';

export default [
    {
        path: "/**/editindex",
        name: "NTKO",
        component: () => import('@/components/NTKO/editindex/editindex.vue'),
    },
    {
        path: '/wel',
        component: Layout,
        redirect: '/wel/index',
        children: [
            {
                path: 'index',
                name: '首页',
                meta: {
                    title: '首页',
                    i18n: 'dashboard',
                    path: '/wel/index'
                },
                component: () =>
                    import('@/views/wel/index')
            }
        ]
    },
    {
        path: '/individualContractor',
        component: Layout,
        redirect: '/individualContractor/index',
        children: [
            {
                path: 'index',
                name: '个人承办列表',
                component: () =>
                    import('@/views/legalManagement/individualContractor/index'),
                meta: {
                    title: '个人承办列表',
                    path: '/individualContractor/index'
                },
            },
        ],
    },
    {
        path: '/cases',
        component: Layout,
        redirect: '/cases/index',
        children: [
            {
                path: 'index',
                name: '立案信息列表',
                component: () =>
                    import('@/views/legalManagement/cases/index'),
                meta: {
                    title: '立案信息列表',
                    path: '/cases/index'

                },
            },
            {
                path: 'details',
                name: '立案信息详情',
                component: () =>
                    import('@/views/legalManagement/cases/details'),
                meta: {
                    title: '立案信息详情',
                    path: '/cases/index'
                },
            }
        ],
    },
    {
        path: '/externalLawyer',
        component: Layout,
        redirect: '/externalLawyer/index',
        children: [
            {
                path: 'index',
                name: '外聘律师列表',
                component: () =>
                    import('@/views/legalManagement/externalLawyer/index'),
                meta: {
                    title: '外聘律师列表',
                    path: '/externalLawyer/index'

                },
            },
            {
                path: 'details',
                name: '外聘律师申请',
                component: () =>
                    import('@/views/legalManagement/externalLawyer/details'),
                meta: {
                    title: '外聘律师申请',
                    path: '/externalLawyer/index'

                },
            },
            {
                path: 'change',
                name: '外聘律师变更',
                component: () =>
                    import('@/views/legalManagement/externalLawyer/change'),
                meta: {
                    title: '外聘律师申请',
                    path: '/externalLawyer/index'

                },
            }
        ],
    },
    {
        path: '/preservation',
        component: Layout,
        redirect: '/preservation/index',
        children: [
            {
                path: 'index',
                name: '保全信息列表',
                component: () =>
                    import('@/views/legalManagement/preservation/preservation_add/index'),
                meta: {
                    title: '保全信息列表',
                    path: '/preservation/index'
                },
            },
            {
                path: 'index3',
                name: '保全信息列表',
                component: () =>
                    import('@/views/legalManagement/preservation/preservation_add/index'),
                meta: {
                    title: '保全信息列表',
                    path: '/preservation/index'
                },
            },
            {
                path: 'details',
                name: '保全信息新增',
                component: () =>
                    import('@/views/legalManagement/preservation/preservation_add/details'),
                meta: {
                    title: '保全信息新增',
                    path: '/preservation/index'

                },
            },
            {

                path: 'index1',
                name: '保全信息查询',
                component: () =>
                    import('@/views/legalManagement/preservation/preservation_register/index'),
                meta: {
                    title: '保全信息查询',
                    path: '/preservation/index'

                },
            },
            {
                path: 'details1',
                name: '保全信息登记',
                component: () =>
                    import('@/views/legalManagement/preservation/preservation_register/details'),
                meta: {
                    title: '保全信息登记',
                    path: '/preservation/index'

                },
            },
            {
                path: 'handleRelieve',
                name: '保全信息解绑',
                component: () =>
                    import('@/views/legalManagement/preservation/preservation_add/relieveDialog'),
                     meta: {
                    title: '保全信息解绑',
                    path: '/preservation/handleRelieve'

                },
            }
        ],
    },
    {
        path: '/arbitration',
        component: Layout,
        name: '仲裁',
        children: [
            {
                path: 'index',
                name: '一般仲裁列表',
                component: () =>
                    import('@/views/legalManagement/arbitration/index'),
                meta: {
                    title: '一般仲裁列表',
                    path: '/arbitration/index'

                },
            },
            {
                path: 'details',
                name: '一般仲裁详情',
                component: () =>
                    import('@/views/legalManagement/arbitration/index/details'),
                meta: {
                    title: '一般仲裁详情',
                    path: '/arbitration/index'

                },
            },
            {
                path: 'preArbitration',
                name: '劳动仲裁列表',
                component: () =>
                    import('@/views/legalManagement/preArbitration'),
                meta: {
                    title: '劳动仲裁列表',
                    path: '/arbitration/preArbitration'

                },
            },
            {
                path: 'preArbitrationDetails',
                name: '劳动仲裁详情',
                component: () =>
                    import('@/views/legalManagement/preArbitration/details'),
                meta: {
                    title: '劳动仲裁详情',
                    path: '/arbitration/preArbitration'

                },
            }
        ]
    },
    {
        path: '/firstInstance',
        component: Layout,
        redirect: '/firstInstance/index',
        children: [
            {
                path: 'index',
                name: '一审案件',
                component: () =>
                    import('@/views/legalManagement/firstInstance/index'),
                meta: {
                    title: '一审案件',
                    path: '/firstInstance/index'
                },
            },
            {
                path: 'details',
                name: '一审信息',
                component: () =>
                    import('@/views/legalManagement/firstInstance/details'),
                meta: {
                    title: '一审信息',
                    path: '/firstInstance/index'

                },
            }
        ],
    },
    {
        path: '/secondInstance',
        component: Layout,
        redirect: '/secondInstance/index',
        children: [
            {
                path: 'index',
                name: '二审案件',
                component: () =>
                    import('@/views/legalManagement/secondInstance/index'),
                meta: {
                    title: '二审案件',
                    path: '/secondInstance/index'
                },
            },
            {
                path: 'details',
                name: '二审信息',
                component: () =>
                    import('@/views/legalManagement/secondInstance/details'),
                meta: {
                    title: '二审信息',
                    path: '/secondInstance/index'

                },
            }
        ],
    },
    {
        path: '/retrial',
        component: Layout,
        redirect: '/retrial/index',
        children: [
            {
                path: 'index',
                name: '再审案件',
                component: () =>
                    import('@/views/legalManagement/retrial/index'),
                meta: {
                    title: '再审案件',
                    path: '/retrial/index'

                },
            },
            {
                path: 'details',
                name: '再审信息',
                component: () =>
                    import('@/views/legalManagement/retrial/details'),
                meta: {
                    title: '再审信息',
                    path: '/retrial/index'

                },
            }
        ],
    },
    {
        path: '/caseExecution',
        component: Layout,
        redirect: '/caseExecution/index',
        children: [
            {
                path: 'index',
                name: '案件执行',
                component: () =>
                    import('@/views/legalManagement/caseExecution/index'),
                meta: {
                    title: '案件执行',
                    path: '/caseExecution/index'
                },
            },
            {
                path: 'details',
                name: '案件执行',
                component: () =>
                    import('@/views/legalManagement/caseExecution/details'),
                meta: {
                    title: '案件执行',
                    path: '/caseExecution/index'
                },
            },
            {
                path: 'resumingExecution',
                name: '恢复执行',
                component: () =>
                    import('@/views/legalManagement/caseExecution/resumingExecution'),
                meta: {
                    title: '案件恢复执行',
                    path: '/caseExecution/index'
                },
            }
        ],
    },
    {
        path: '/caseClosed',
        component: Layout,
        redirect: '/caseClosed/index',
        children: [
            {
                path: 'index',
                name: '案件结案',
                component: () =>
                    import('@/views/legalManagement/caseClosed/index'),
                meta: {
                    title: '案件结案',
                    path: '/caseClosed/index'

                },
            },
            {
                path: 'details',
                name: '案件结案信息',
                component: () =>
                    import('@/views/legalManagement/caseClosed/details'),
                meta: {
                    title: '案件结案信息',
                    path: '/caseClosed/index'

                },
            }
        ],
    },
    {
        path: '/caseProcess',
        component: Layout,
        redirect: '/caseProcess/index',
        children: [
            {
                path: 'index',
                name: '案件过程',
                component: () =>
                    import('@/views/legalManagement/caseProcess/index'),
                meta: {
                    title: '案件过程',
                    path: '/caseProcess/index'
                },
            },
            {
                path: 'details',
                name: '案件过程信息',
                component: () =>
                    import('@/views/legalManagement/caseProcess/details'),
                meta: {
                    title: '案件过程信息',
                    path: '/caseProcess/index'

                },
            }
        ],
    },
    {
        path: '/caseReview',
        component: Layout,
        redirect: '/caseReview/index',
        children: [
            {
                path: 'index',
                name: '案件审核',
                component: () =>
                    import('@/views/legalManagement/caseReview/index'),
                meta: {
                    title: '案件审核',
                    path: '/caseReview/index'

                },
            },
            {
                path: 'details',
                name: '案件审核信息',
                component: () =>
                    import('@/views/legalManagement/caseReview/details'),
                meta: {
                    title: '案件审核信息',
                    path: '/caseReview/index'

                },
            }
        ],
    },
    {
        path: '/IntegratedQuery',
        component: Layout,
        redirect: '/IntegratedQuery/index',
        children: [
            {
                path: 'index',
                name: '案件综合查询',
                component: () =>
                    import('@/views/legalManagement/IntegratedQuery/index'),
                meta: {
                    title: '案件综合查询',
                    path: '/IntegratedQuery/index'
                },
            },
            {
                path: 'details',
                name: '案件信息',
                component: () =>
                    import('@/views/legalManagement/IntegratedQuery/details'),
                meta: {
                    title: '案件信息',
                    path: '/IntegratedQuery/index'
                },
            }
        ],
    },
    {
        path: '/supplementaryApproval',
        component: Layout,
        redirect: '/supplementaryApproval/index',
        children: [
            {
                path: 'index',
                name: '补充审批',
                component: () =>
                    import('@/views/legalManagement/supplementaryApproval/index.vue'),
                meta: {
                    title: '补充审批',
                    path: '/IntegratedQuery/index'
                },
            },

        ],
    },
    {
        path: '/booksManagement',
        component: Layout,
        redirect: '/booksManagement/index',
        children: [
            {
                path: 'index',
                name: '案卷管理',
                component: () =>
                    import('@/views/documentManagement/booksManagement/index'),
                meta: {
                    title: '案卷管理',
                    path: '/booksManagement/index'
                },
            }, {
                path: 'upload',
                name: '案卷上传',
                component: () =>
                    import('@/views/documentManagement/booksManagement/attachmentUpload/index'),
                meta: {
                    title: '案卷管理',
                    path: '/booksManagement/index'
                },
            },
            {
                path: 'download',
                name: '案卷下载',
                component: () =>
                    import('@/views/documentManagement/booksManagement/attachmentDownload/index'),
                meta: {
                    title: '案卷管理',
                    path: '/booksManagement/index'
                },
            },
        ],
    },
    {
        path: '/caseModel',
        component: Layout,
        redirect: '/caseModel/index',
        children: [
            {
                path: 'index',
                name: '法律文书范本',
                component: () =>
                    import('@/views/documentManagement/caseModel/index'),
                meta: {
                    title: '法律文书范本',
                    path: '/caseModel/index'
                },
            },
            {
                path: 'details',
                name: '法律文书范本信息',
                component: () =>
                    import('@/views/documentManagement/caseModel/details'),
                meta: {
                    title: '法律文书范本',
                    path: '/caseModel/index'
                },
            }
        ],
    },
    {
        path: '/workHandover',
        component: Layout,
        redirect: '/workHandover/index',
        children: [
            {
                path: 'index',
                name: '工作交接',
                component: () =>
                    import('@/views/workHandoverManagement/workHandover/index'),
                meta: {
                    title: '工作交接',
                    path: '/workHandover/index'
                },
            },
        ],
    },
    {
        path: '/handoverRecord',
        component: Layout,
        redirect: '/handoverRecord/index',
        children: [
            {
                path: 'index',
                name: '交接记录',
                component: () =>
                    import('@/views/workHandoverManagement/handoverRecord/index'),
                meta: {
                    title: '交接记录',
                    path: '/handoverRecord/index'
                },
            },
            {
                path: 'details',
                name: '交接记录信息',
                component: () =>
                    import('@/views/workHandoverManagement/handoverRecord/details'),
                meta: {
                    title: '交接记录信息',
                    path: '/handoverRecord/index'
                },
            },
        ],
    },
    {
        path: '/processAuthorization',
        component: Layout,
        redirect: '/processAuthorization/index',
        children: [
            {
                path: 'index',
                name: '流程授权',
                component: () =>
                    import('@/views/processAuthorization/index'),
                meta: {
                    title: '流程授权',
                    path: '/processAuthorization/index'
                },
            },
        ],
    },
    {
        path: '/management',
        component: Layout,
        redirect: '/management/index',
        children: [
            {
                path: 'index',
                name: '角色管理',
                component: () =>
                    import('@/views/role/index'),
                meta: {
                    title: '角色管理',
                    path: '/management/index'
                },
            },
            {
                path: 'detail',
                name: '角色信息',
                component: () =>
                    import('@/views/role/detail'),
                meta: {
                    title: '角色信息',
                    path: '/management/index'
                },
            },
        ],
    },
    {
        path: '/court',
        component: Layout,
        redirect: '/court/address',
        children: [
            {
                path: 'address',
                name: '法院管理',
                component: () =>
                    import('@/views/court/address'),
                meta: {
                    title: '法院名称',
                    path: '/court/address'
                },
            },
            {
                path: 'addressDetail',
                name: '法院信息',
                component: () =>
                    import('@/views/court/address/detail'),
                meta: {
                    title: '法院名称',
                    path: '/court/address'
                },
            },
            {
                path: 'arbitralCourt',
                name: '仲裁庭',
                component: () =>
                    import('@/views/court/arbitralCourt'),
                meta: {
                    title: '仲裁庭',
                    path: '/court/arbitralCourt'
                },
            },
            {
                path: 'arbitralDetail',
                name: '仲裁庭信息',
                component: () =>
                    import('@/views/court/arbitralCourt/detail'),
                meta: {
                    title: '仲裁庭',
                    path: '/court/arbitralCourt'
                },
            },
        ],
    },
    {
        path: '/structure',
        component: Layout,
        redirect: '/structure/index',
        children: [
            {
                path: 'index',
                name: '组织架构',
                component: () =>
                    import('@/views/organization/index'),
                meta: {
                    title: '组织架构',
                    path: '/structure/index'
                },
            },
            {
                path: 'user_detail',
                name: '员工信息',
                component: () =>
                    import('@/views/organization/components/user_detail'),
                meta: {
                    title: '员工信息',
                    path: '/structure/index'
                },
            },
        ],
    },
    {
        path: '/reminders',
        component: Layout,
        redirect: '/reminders/index',
        children: [
            {
                path: 'index',
                name: '消息提醒',
                component: () =>
                    import('@/views/reminders/index'),
                meta: {
                    title: '消息提醒',
                    path: '/reminders/index'
                },
            },
            {
                path: 'detail',
                name: '消息提醒',
                component: () =>
                    import('@/views/reminders/detail'),
                meta: {
                    title: '消息提醒信息',
                    path: '/reminders/index'
                },
            },
        ],
    },
    {
        path: '/company',
        component: Layout,
        redirect: '/company/index',
        children: [
            {
                path: 'index',
                name: '合规单位',
                component: () =>
                    import('@/views/generalCompliance/company/index'),
                meta: {
                    title: '合规单位',
                    path: '/company/index'
                },
            },
        ],
    },
    {
        path: '/dict',
        component: Layout,
        redirect: '/dict/index',
        children: [
            {
                path: 'index',
                name: '字典管理',
                component: () =>
                    import('@/views/system/dict/dict_list'),
                meta: {
                    title: '字典管理',
                    path: '/dict/index'

                },
            },
            {
                path: 'dict_detail',
                name: '字典管理',
                component: () =>
                    import('@/views/system/dict/dict_detail'),
                meta: {
                    title: '字典管理',
                    path: '/dict/index'

                },
            }
        ],
    },
    {
        path: '/resourceManagementLogin',
        component: Layout,
        redirect: '/resourceManagementLogin/index',
        children: [
            {
                path: 'index',
                name: '资源管理登录',
                meta: {
                    title: '资源管理登录',
                    path: '/resourceManagementLogin/index'
                },
                component: () =>
                    import('@/views/resourceManagement/resourceManagementLogin/index')
            }
        ]
    },
    {
        path: '/resourceUser',
        component: Layout,
        redirect: '/resourceUser/index',
        children: [
            {
                path: 'index',
                name: '法律资源库人员信息',
                meta: {
                    title: '法律资源库人员信息',
                    path: '/resourceUser/index'
                },
                component: () =>
                    import('@/views/resourceManagement/resourceUser/index')
            }
        ]
    },
    {
        path: '/litigation',
        component: Layout,
        redirect: '/litigation/index',
        children: [
            {
                path: 'index',
                name: '诉讼',
                meta: {
                    title: '诉讼',
                    path: '/litigation/index'
                },
                component: () =>
                    import('@/views/resourceManagement/litigation/index')
            },
            {
                path: 'lawyerDetails',
                name: '律师库',
                meta: {
                    title: '律师库',
                    path: '/litigation/index'
                },
                component: () =>
                    import('@/views/resourceManagement/litigation/lawyerLibrary/lawyerLibrary_detail')
            }
            ,
            {
                path: 'lawFirmLibraryDetail',
                name: '律所库',
                meta: {
                    title: '律所库',
                    path: '/litigation/index'
                },
                component: () =>
                    import('@/views/resourceManagement/litigation/lawFirmLibrary/lawFirmLibrary_detail')
            }
            ,
            {
                path: 'lawyerEvaluationDetail',
                name: '律师评分',
                meta: {
                    title: '律师评分',
                    path: '/litigation/index'
                },
                component: () =>
                    import('@/views/resourceManagement/litigation/lawyerEvaluation/lawyerEvaluation_detail')
            },
            {
                path: 'lawFirmEvaluationDetail',
                name: '律所评分',
                meta: {
                    title: '律所评分',
                    path: '/litigation/index'
                },
                component: () =>
                    import('@/views/resourceManagement/litigation/lawFirmEvaluation/lawFirmEvaluation_detail')
            }
        ]
    },
    {
        path: '/nonLitigation',
        component: Layout,
        redirect: '/nonLitigation/index',
        children: [
            {
                path: 'index',
                name: '非诉',
                meta: {
                    title: '非诉',
                    path: '/nonLitigation/index'
                },
                component: () =>
                    import('@/views/resourceManagement/nonLitigation/index')
            }
        ]
    },
    {
        path: '/outsideBorders',
        component: Layout,
        redirect: '/outsideBorders/index',
        children: [
            {
                path: 'index',
                name: '境外',
                meta: {
                    title: '境外',
                    path: '/outsideBorders/index'
                },
                component: () =>
                    import('@/views/resourceManagement/outsideBorders/index')
            }
        ]
    },
    {
        path: '/intellectualProperty',
        component: Layout,
        redirect: '/intellectualProperty/index',
        children: [
            {
                path: 'index',
                name: '知识产权',
                meta: {
                    title: '知识产权',
                    path: '/intellectualProperty/index'
                },
                component: () =>
                    import('@/views/resourceManagement/intellectualProperty/index')
            }
        ]
    },
    {
        path: '/caseSupervision',
        component: Layout,
        redirect: '/caseSupervision/index',
        children: [
            {
                path: 'index',
                name: '案件督办',
                meta: {
                    title: '案件督办',
                    path: '/caseSupervision/index'
                },
                component: () =>
                    import('@/views/resourceManagement/caseSupervision/index')
            }
        ]
    },
    {
        path: '/legalInstrument',
        component: Layout,
        children: [
            {
                path: 'index',
                name: '法律文书范本',
                component: () =>
                    import('@/views/documentManagement/legalInstrument/index'),
                meta: {
                    title: '法律文书范本',
                    path: '/legalInstrument/index'
                },
            },
            {
                path: 'details',
                name: '法律文书范本',
                component: () =>
                    import('@/views/documentManagement/legalInstrument/details'),
                meta: {
                    title: '法律文书范本',
                    path: '/legalInstrument/index'

                },
            }
        ]
    },
    {
        path: '/caseFile',
        component: Layout,
        children: [
            {
                path: 'index',
                name: '案件文件',
                component: () =>
                    import('@/views/documentManagement/caseFile/index'),
                meta: {
                    title: '案件文件',
                    path: '/caseFile/index'
                },
            }
        ]
    },
    {
        path: '/commonGuidelines',
        component: Layout,
        redirect: '/commonGuidelines/index',
        children: [
            {
                path: 'index',
                name: '常用指引',
                component: () =>
                    import('@/views/documentManagement/commonGuidelines/index'),
                meta: {
                    title: '常用指引',
                    path: '/caseFile/index'
                },
            }
        ]
    },
    {
        path: '/workHandover',
        component: Layout,
        redirect: '/workHandover/workHandover_list',
        children: [
            {
                path: 'workHandover_list',
                name: '工作交接',
                meta: {
                    title: '工作交接',
                    path: '/workHandover/index'
                },
                component: () =>
                    import('@/views/systemManagement/workHandover/workHandover_list')
            }
        ]
    },
    {
        path: '/handoverRecord',
        component: Layout,
        redirect: '/handoverRecord/handoverRecord_list',
        children: [
            {
                path: 'handoverRecord_list',
                name: '交接纪录',
                meta: {
                    title: '交接纪录',
                    path: '/handoverRecord/handoverRecord_list'
                },
                component: () =>
                    import('@/views/systemManagement/handoverRecord/handoverRecord_list')
            }
        ]
    },
    {
        path: '/processAuthorization',
        component: Layout,
        redirect: '/processAuthorization/processAuthorization_list',
        children: [
            {
                path: 'processAuthorization_list',
                name: '流程授权',
                meta: {
                    title: '流程授权',
                    path: '/processAuthorization/processAuthorization_list'
                },
                component: () =>
                    import('@/views/systemManagement/processAuthorization/processAuthorization_list')
            }
        ]
    },
    {
        path: '/pperationLog',
        component: Layout,
        redirect: '/pperationLog/pperationLog_list',
        children: [
            {
                path: 'pperationLog_list',
                name: '操作日志',
                meta: {
                    title: '操作日志',
                    path: '/pperationLog/pperationLog_list'
                },
                component: () =>
                    import('@/views/0perationLog/index')
            }
        ]
    },
    {
        path: '/commonlyUsedGuide',
        component: Layout,
        redirect: '/commonlyUsedGuide/index',
        children: [
            {
                path: 'index',
                name: '常用指引',
                meta: {
                    title: '常用指引',
                    path: '/processAuthorization/processAuthorization_list'
                },
                component: () =>
                    import('@/views/documentManagement/commonlyUsedGuide')
            }
        ]
    },
    {
        path: '/complianceDeclare',
        component: Layout,
        redirect: '/complianceDeclare/index',
        children: [
            {
                path: 'index',
                name: '合规申报列表',
                component: () =>
                    import('@/views/generalCompliance/complianceDeclare/index'),
                meta: {
                    title: '合规申报',
                    path: '/complianceDeclare/index'
                },
            },
            {
                path: 'details',
                name: '合规申报信息',
                component: () =>
                    import('@/views/generalCompliance/complianceDeclare/details'),
                meta: {
                    title: '合规申报',
                    path: '/complianceDeclare/index'
                },
            },

        ],
    },
    {
        path: '/complianceudits',
        component: Layout,
        redirect: '/complianceudits/index',
        children: [
            {
                path: 'index',
                name: '合规自查列表',
                component: () =>
                    import('@/views/generalCompliance/complianceudits/index'),
                meta: {
                    title: '合规自查列表',
                    path: '/complianceudits/index'
                },
            },
            {
                path: 'details',
                name: '合规自查信息',
                component: () =>
                    import('@/views/generalCompliance/complianceudits/details'),
                meta: {
                    title: '合规自查列表',
                    path: '/complianceudits/index'
                },
            },

        ],
    },

    {
        path: '/complianceAudit',
        component: Layout,
        redirect: '/complianceAudit/index',
        children: [
            {
                path: 'index',
                name: '合规抽查列表',
                component: () =>
                    import('@/views/generalCompliance/complianceAudit/index'),
                meta: {
                    title: '合规抽查列表',
                    path: '/complianceAudit/index'
                },
            },
            {
                path: 'details',
                name: '合规抽查信息',
                component: () =>
                    import('@/views/generalCompliance/complianceAudit/details'),
                meta: {
                    title: '合规抽查列表',
                    path: '/complianceAudit/index'
                },
            },

        ],
    },
    {
        path: '/complianceScore',
        component: Layout,
        redirect: '/complianceScore/index',
        children: [
            {
                path: 'index',
                name: '合规评分列表',
                component: () =>
                    import('@/views/generalCompliance/complianceScore/index'),
                meta: {
                    title: '合规评分列表',
                    path: '/complianceScore/index'
                },
            },
            {
                path: 'riskPoint',
                name: '风险点信息',
                component: () =>
                    import('@/views/generalCompliance/complianceScore/riskPoint'),
                meta: {
                    title: '风险点信息',
                    path: '/complianceScore/index'
                },
            },
            {
                path: 'details',
                name: '整改备案信息',
                component: () =>
                    import('@/views/generalCompliance/complianceScore/details'),
                meta: {
                    title: '整改备案信息',
                    path: '/complianceScore/index'
                },
            },

        ],
    },
    {
        path: '/complianceRanking',
        component: Layout,
        redirect: '/complianceRanking/index',
        children: [
            {
                path: 'index',
                name: '合规排名列表',
                component: () =>
                    import('@/views/generalCompliance/complianceRanking/index'),
                meta: {
                    title: '合规排名列表',
                    path: '/complianceScore/index'
                },
            },


        ],
    },
    {
        path: '/complianceCorrective',
        component: Layout,
        redirect: '/complianceCorrective/index',
        children: [
            {
                path: 'index',
                name: '合规整改列表',
                component: () =>
                    import('@/views/generalCompliance/complianceCorrective/index'),
                meta: {
                    title: '合规整改列表',
                    path: '/complianceCorrective/index'
                },
            },
            {
                path: 'details',
                name: '整改备案',
                component: () =>
                    import('@/views/generalCompliance/complianceCorrective/details'),
                meta: {
                    title: '整改备案信息',
                    path: '/complianceCorrective/index'
                },
            },


        ],
    },
    {
        path: '/auditMatters',
        component: Layout,
        redirect: '/auditMatters/index',
        children: [
            {
                path: 'index',
                name: '合规审批列表',
                component: () =>
                    import('@/views/generalCompliance/auditMatters/index'),
                meta: {
                    title: '合规审批列表',
                    path: '/auditMatters/index'
                },
            },


        ],
    },
    {
        path: '/securities',
        component: Layout,
        redirect: '/securities/index',
        children: [
            {
                path: 'index',
                name: '内幕防控',
                component: () =>
                    import('@/views/compliance/securities/Insider/index'),
                meta: {
                    title: '内幕防控',
                    path: '/securities/index'
                },
            },
            {
                path: 'details',
                name: '内幕防控信息',
                component: () =>
                    import('@/views/compliance/securities/Insider/tab/first/detail'),
                meta: {
                    title: '内幕防控信息',
                    path: '/securities/index'

                },
            },
            {
                path: 'secondDetails',
                name: '知情人登记信息',
                component: () =>
                    import('@/views/compliance/securities/Insider/tab/second/detail'),
                meta: {
                    title: '知情人登记信息',
                    path: '/securities/index'

                },
            },
            {
                path: 'thirdDetail',
                name: '移出记录信息',
                component: () =>
                    import('@/views/compliance/securities/Insider/tab/third/components/removeDetail'),
                meta: {
                    title: '移出记录信息',
                    path: '/securities/index'

                },
            },
            {
                path: 'third_detail',
                name: '禁投池移出',
                component: () =>
                    import('@/views/compliance/securities/Insider/tab/third/components/poolDialog'),
                meta: {
                    title: '禁投池移出',
                    path: '/securities/third_detail'
                },
            },
            {
                path: 'pool_application',
                name: '禁投池申请',
                component: () =>
                    import('@/views/compliance/securities/Insider/pool_applicetion'),
                meta: {
                    title: '禁投池申请',
                    path: '/securities/pool_application'
                },
            },
            {
                path: 'prohibit_detail',
                name: '禁投池详情',
                component: () =>
                    import('@/views/compliance/securities/Insider/tab/third/components/prohibit_detail'),
                meta: {
                    title: '禁投池详情',
                    path: '/securities/prohibit_detail'
                },
            },
        ],
    },
    {
        path: '/shares',
        component: Layout,
        redirect: '/shares/index',
        children: [
            {
                path: 'index',
                name: '股份变动',
                component: () =>
                    import('@/views/compliance/securities/shares/index'),
                meta: {
                    title: '股份变动',
                    path: '/shares/index'
                },
            },
            {
                path: 'details',
                name: '股份申报信息',
                component: () =>
                    import('@/views/compliance/securities/shares/tab/first/detail'),
                meta: {
                    title: '股份申报信息',
                    path: '/shares/index'

                },
            },
            {
                path: 'secondDetails',
                name: '股份变动登记信息',
                component: () =>
                    import('@/views/compliance/securities/shares/tab/second/detail'),
                meta: {
                    title: '股份变动登记信息',
                    path: '/shares/index'

                },
            },
        ]
    },
    {
        path: '/Information',
        component: Layout,
        redirect: '/Information/index',
        children: [
            {
                path: 'index',
                name: '信息披露',
                component: () =>
                    import('@/views/compliance/securities/Information/index'),
                meta: {
                    title: '信息披露',
                    path: '/shares/index'
                },
            },
            {
                path: 'details',
                name: '申报信息',
                component: () =>
                    import('@/views/compliance/securities/Information/detail'),
                meta: {
                    title: '申报信息',
                    path: '/shares/index'

                },
            },
            {
                path: 'disclosure',
                name: '信息披露信息',
                component: () =>
                    import('@/views/compliance/securities/Information/disclosure'),
                meta: {
                    title: '信息披露信息',
                    path: '/shares/index'

                },
            },
        ]
    },
    {
        path: '/complianceApproved',
        component: Layout,
        redirect: '/complianceApproved/index',
        children: [
            {
                path: 'index',
                name: '合规审核',
                meta: {
                    title: '合规审核',
                    path: '/complianceApproved/index'
                },
                component: () =>
                    import('@/views/compliance/approved/index'),
            }
        ]
    },
    {
        path: '/comprehensiveComplianceInquiry',
        component: Layout,
        redirect: '/comprehensiveComplianceInquiry/index',
        children: [
            {
                path: 'index',
                name: '综合查询列表',
                meta: {
                    title: '综合查询',
                    path: '/comprehensiveComplianceInquiry/index'
                },
                component: () =>
                    import('@/views/generalCompliance/comprehensiveComplianceInquiry/index'),
            }
        ]
    },
    {
        path: '/complianceToPush',
        component: Layout,
        redirect: '/complianceToPush/index',
        children: [
            {
                path: 'index',
                name: '合规推送列表',
                meta: {
                    title: '合规推送列表',
                    path: '/complianceToPush/index'
                },
                component: () =>
                    import('@/views/generalCompliance/complianceToPush/index'),
            },
            {
                path: 'details',
                name: '合规推送信息',
                meta: {
                    title: '合规推送列表',
                    path: '/complianceToPush/index'
                },
                component: () =>
                    import('@/views/generalCompliance/complianceToPush/details'),
            }
        ]
    },
    {
        path: '/complianceDistribution',
        component: Layout,
        redirect: '/complianceDistribution/index',
        children: [
            {
                path: 'index',
                name: '合规分配列表',
                meta: {
                    title: '合规分配列表',
                    path: '/complianceDistribution/index'
                },
                component: () =>
                    import('@/views/generalCompliance/complianceDistribution/index'),
            },
            {
                path: 'expertsReply',
                name: '专家答复列表',
                meta: {
                    title: '合规分配列表',
                    path: '/complianceDistribution/index'
                },
                component: () =>
                    import('@/views/generalCompliance/complianceDistribution/expertsReply'),
            }
        ]
    },
    {
        path: '/complianceConsulting',
        component: Layout,
        redirect: '/complianceConsulting/index',
        children: [
            {
                path: 'index',
                name: '合规咨询列表',
                meta: {
                    title: '合规咨询列表',
                    path: '/complianceConsulting/index'
                },
                component: () =>
                    import('@/views/generalCompliance/complianceConsulting/index'),
            },
            {
                path: 'details',
                name: '合规咨询信息',
                meta: {
                    title: '合规咨询信息',
                    path: '/complianceConsulting/index'
                },
                component: () =>
                    import('@/views/generalCompliance/complianceConsulting/details'),
            }
        ]
    },
    {
        path: '/processRole',
        component: Layout,
        redirect: '/processRole/index',
        children: [
            {
                path: 'index',
                name: '流程角色配置',
                meta: {
                    title: '流程角色配置',
                    path: '/processRole/index'
                },
                component: () =>
                    import('@/views/process/role/index'),
            },
            {
                path: 'detail',
                name: '流程角色配置信息',
                meta: {
                    title: '流程角色配置信息',
                    path: '/processRole/detail'
                },
                component: () =>
                    import('@/views/process/role/detail'),
            }
        ]
    },
    {
        path: '/processDefinition',
        component: Layout,
        redirect: '/processDefinition/index',
        children: [
            {
                path: 'index',
                name: '流程定义',
                meta: {
                    title: '流程定义',
                    path: '/processDefinition/index'
                },
                component: () =>
                    import('@/views/process/definition/index'),
            },
            {
                path: 'detail',
                name: '流程定义信息',
                meta: {
                    title: '流程定义信息',
                    path: '/processDefinition/detail'
                },
                component: () =>
                    import('@/views/process/definition/detail'),
            }
        ]
    },
    {
        path: '/file',
        component: Layout,
        redirect: '/file/index',
        children: [
            {
                path: 'index',
                name: '合规文件上传',
                meta: {
                    title: '合规文件上传',
                    path: '/file/index'
                },
                component: () =>
                    import('@/views/generalCompliance/riskPool/file/index'),
            },
            {
                path: 'detail',
                name: '合规文件上传信息',
                meta: {
                    title: '合规文件上传信息',
                    path: '/file/detail'
                },
                component: () =>
                    import('@/views/generalCompliance/riskPool/file/detail'),
            }
        ]
    },
    {
        path: '/riskItem',
        component: Layout,
        redirect: '/riskItem/index',
        children: [
            {
                path: 'index',
                name: '合规风险项待审核清单',
                meta: {
                    title: '合规风险项待审核清单',
                    path: '/riskItem/index'
                },
                component: () =>
                    import('@/views/generalCompliance/riskPool/riskItem/index'),
            },
            {
                path: 'detail',
                name: '合规风险项待审核清单信息',
                meta: {
                    title: '合规风险项待审核清单信息',
                    path: '/riskItem/detail'
                },
                component: () =>
                    import('@/views/generalCompliance/riskPool/riskItem/detail'),
            }
        ]
    },
    {
        path: '/pool',
        component: Layout,
        redirect: '/pool/index',
        children: [
            {
                path: 'index',
                name: '合规风险库',
                meta: {
                    title: '合规风险库',
                    path: '/pool/index'
                },
                component: () =>
                    import('@/views/generalCompliance/riskPool/pool/index'),
            },
        ]
    },
    {
        path: '/riskCategory',
        component: Layout,
        redirect: '/riskCategory/index',
        children: [
            {
                path: 'index',
                name: '风险类别维护',
                meta: {
                    title: '风险类别维护',
                    path: '/riskCategory/index'
                },
                component: () =>
                    import('@/views/generalCompliance/riskPool/riskCategory/index'),
            },
            {
                path: 'detail',
                name: '风险类别维护信息',
                meta: {
                    title: '风险类别维护信息',
                    path: '/riskCategory/detail'
                },
                component: () =>
                    import('@/views/generalCompliance/riskPool/riskCategory/detail'),
            }
        ]
    },
    {
        path: '/transition',
        component: Layout,
        redirect: '/transition/transition_detail',
        children: [
            {
                path: 'transition_detail',
                name: '案件转阶段',
                component: () =>
                    import('@/views/legalManagement/transition/transition_detail'),
                meta: {
                    title: '案件转阶段',
                    path: '/transition/transition_detail'
                },
            },
        ],
    },
];
